@let files = $files();
@let fileCats = $fileCats();

@if (viewScreen() === ViewScreenType.Download) {
  <x-request-form-files-download
    [fileCats]="fileCats"
    [isInsideSummary]="true"
  />
} @else {
  <x-request-form-files-common
    [isInsideSummary]="true"
    [showFileModal]="$showFileModal()"
    [files]="files"
    [fileCats]="fileCats"
    [requestFilesPersonType]="
      viewScreen() === ViewScreenType.Installer
        ? RequestFilesPerson.INSTALLER
        : RequestFilesPerson.CLIENT
    "
  />
}
